export const titleNormalized = 'chatbot-skin';
export const appLanguage = 'french'